/* eslint-disable global-require */
import angular from 'angular';

import { ImageUploadController } from './image-upload.controller';
import './image-upload.styles.scss';

export const FormImageUpload = {
  selector: 'formUploadImage',
  controller: ImageUploadController,
  bindings: {
    exit: '&',
    show: '=',
    vehicle: '<',
  },
  template: /* html */ `
    <form class="default-form backdrop-overlay-form image-upload-form" ng-submit="formTransmission()" ng-if="$ctrl.show">
      <div class="box-wrap">
        <div class="boxL">
          <h3>Fahrzeugbilder Upload</h3>
          <p class="subtitle">
            Upload von .JPG oder .PNG Dateien. Maximale Dateigröße 15MB.
          </p>

          <div class="row">
            <div class="dropzone col-12" options="$ctrl.dropzoneOptions" methods="$ctrl.dropzoneMethods" callbacks="$ctrl.dropzoneCallbacks" ng-dropzone></div>

            <span>{{ $ctrl.fileStats.uploaded }} von {{ $ctrl.fileStats.total }} Bildern hochgeladen</span>
          </div>

          <div class="btn-wrap right">
            <button type="button" ng-click="$ctrl.uploadQueue()" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.sending}" ng-disabled="$ctrl.sending" >Bilder hochladen</button>
          </div>
        </div>

        <div class="boxL" ng-if="$ctrl.vehicleImages.length">
          <h3>Bilder ({{$ctrl.vehicleImages.length}}) verwalten</h3>
          <p class="subtitle">
            Die Reihenfolge der Bilder lässt sich per Drag & Drop anpassen.
          </p>

          <ul dnd-list="$ctrl.vehicleImages"
            dnd-horizontal-list="true"
            dnd-drop="$ctrl.onDrop(callback(), index)"
            class="itemlist"
          >
            <li ng-repeat="image in $ctrl.vehicleImages track by $index"
                dnd-draggable="image"
                dnd-callback="$index"
            >
              <img src="{{image.url}}" />
              <div class="btn-wrap center">
                <button type="button" class="btn-lvl3" ng-click="$ctrl.removeImage(image.staticId)">
                  <svg class="ab-icon"><use xlink:href="#btn-delete"></use></svg>
                </button>
              </div>
            </li>
          </ul>
        </div>

        <div class="boxL" ng-if="$ctrl.vehicle.apiData.LINK_ENTRY">
          <div class="intro">
            <h3>Beispielbilder generieren</h3>
            <p>Achtung: Diese Aktion löscht alle existierenden Bilder.</p>
          </div>

          <div class="btn-wrap">
            <div class="btn-wrap right">
              <button
                type="button"
                ng-click="$ctrl.regenImages()"
                class="btn-lvl1"
                ng-class="{'btn-sending': $ctrl.sending}"
                ng-disabled="$ctrl.sending"
              >Bilder generieren</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  `,
};

export default angular.module('directives.formImageUpload', [])
  .component(FormImageUpload.selector, FormImageUpload)
  .name;
